import _Object$keys from "@babel/runtime-corejs2/core-js/object/keys";
import _regeneratorRuntime from "@babel/runtime-corejs2/regenerator";
import _Promise from "@babel/runtime-corejs2/core-js/promise";
import _asyncToGenerator from "@babel/runtime-corejs2/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime-corejs2/helpers/classCallCheck";
import _defineProperty from "@babel/runtime-corejs2/helpers/defineProperty";
import axios from 'axios';
import { videoSources } from '@dmi-mch/constants';
import { logger as Logger } from '@dmi-mch/utils';

var Videoinfo = function Videoinfo(videoId, videoType) {
  var _this = this;

  _classCallCheck(this, Videoinfo);

  _defineProperty(this, "info", null);

  _defineProperty(this, "getInfo", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var promise;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            promise = new _Promise(function (resolve, reject) {
              if (_this.videoType === 1) {
                try {
                  var vimeoResponse = axios.get("https://vimeo.com/api/v2/video/".concat(_this.videoId, ".json"));
                  vimeoResponse.then(function (response) {
                    if (response.status === 200) {
                      _this.info = response;
                      resolve(response);
                    } else {
                      reject(response);
                    }
                  }).catch(function () {
                    resolve({});
                  });
                } catch (e) {
                  Logger(e);
                }
              } else if (_this.videoType === 0) {
                var prefix = 'http://i1.ytimg.com/vi/';
                var output = [];
                output['0'] = "".concat(prefix).concat(_this.videoId, "/0.jpg");
                output['1'] = "".concat(prefix).concat(_this.videoId, "/1.jpg");
                output['2'] = "".concat(prefix).concat(_this.videoId, "/2.jpg");
                output['3'] = "".concat(prefix).concat(_this.videoId, "/3.jpg");
                output.default = "".concat(prefix).concat(_this.videoId, "/default.jpg");
                output.hqdefault = "".concat(prefix).concat(_this.videoId, "/hqdefault.jpg");
                output.mqdefault = "".concat(prefix).concat(_this.videoId, "/mqdefault.jpg");
                output.sddefault = "".concat(prefix).concat(_this.videoId, "/sddefault.jpg");
                _this.info = output;
                resolve(output);
              }
            });
            return _context.abrupt("return", promise);

          case 2:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  })));

  _defineProperty(this, "getThumbnail", function () {
    if (_this.videoType === 0) {
      return _this.info.default;
    } else if (_this.videoType === 1) {
      return _this.info.data[0].thumbnail_medium;
    }

    return null;
  });

  _defineProperty(this, "getRegular", function () {
    if (_this.videoType === 0) {
      return _this.info['0'];
    } else if (_this.videoType === 1) {
      return _this.info.data[0].thumbnail_large;
    }

    return null;
  });

  _defineProperty(this, "getVideoTypeName", function () {
    var videoName = _Object$keys(videoSources).find(function (item) {
      return videoSources[item].id === _this.videoType;
    });

    return videoSources[videoName].name;
  });

  _defineProperty(this, "getLink", function () {
    if (_this.videoType === 0) {
      return "https://www.youtube.com/watch?v=".concat(_this.videoId);
    } else if (_this.videoType === 1) {
      return "https://vimeo.com/".concat(_this.videoId);
    }

    return null;
  });

  this.videoId = videoId;
  this.videoType = videoType;
}
/* Will contain the result of the API */
;

export default Videoinfo;